import { createReducer } from "typesafe-actions";

import type { FiCatalogResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";
import type Organization from "@mapmycustomers/shared/types/Organization";

import TextSearchResult from "@app/types/TextSearchResult";

import {
  Actions,
  clearEntityMentionSearch,
  fetchMentionCharts,
  searchEntityMentions,
} from "./actions";

export interface EntityMentionsState {
  charts: FiCatalogResponse[];
  chartsLoading: boolean;
  chartsOrganizationId?: Organization["id"]; // org the catalog was requested for
  searchedQuery: string;
  searchLoading: boolean;
  searchResults: TextSearchResult[];
}

const initialState: EntityMentionsState = {
  charts: [],
  chartsLoading: false,
  searchedQuery: "",
  searchLoading: false,
  searchResults: [],
};

const entityMentions = createReducer<EntityMentionsState, Actions>(initialState)
  // The org id is stamped on request rather than on success, so a lookup that
  // fails isn't retried by every consumer that mounts afterwards — an
  // unresolved marker simply keeps showing as not available.
  .handleAction(fetchMentionCharts.request, (state, { payload: { organizationId } }) => ({
    ...state,
    charts: [],
    chartsLoading: true,
    chartsOrganizationId: organizationId,
  }))
  .handleAction(fetchMentionCharts.success, (state, { payload: { charts } }) => ({
    ...state,
    charts,
    chartsLoading: false,
  }))
  .handleAction(fetchMentionCharts.failure, (state) => ({
    ...state,
    chartsLoading: false,
  }))
  .handleAction(searchEntityMentions.request, (state, { payload: { query } }) => ({
    ...state,
    searchedQuery: query,
    searchLoading: true,
    searchResults: [],
  }))
  .handleAction(searchEntityMentions.success, (state, { payload: { results } }) => ({
    ...state,
    searchLoading: false,
    searchResults: results,
  }))
  .handleAction(searchEntityMentions.failure, (state) => ({
    ...state,
    searchLoading: false,
    searchResults: [],
  }))
  .handleAction(clearEntityMentionSearch, (state) => ({
    ...state,
    searchedQuery: "",
    searchLoading: false,
    searchResults: [],
  }));

export type EntityMentionsActions = Actions;

export default entityMentions;
